import { makeStyles } from "@material-ui/core";
import { Colors } from "../../utils";

const makeClasses = makeStyles((theme) => ({
  dialog: {
    maxWidth: "unset",
  },
  dialogTitleWrapper: {
    background: Colors.rgb.black_light,
    padding: "1.25rem",
    color: Colors.rgb.white,
    "& h2": {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      "& div": {
        display: "flex",
        alignItems: "center",
      },
    },
  },
  dialogContentWrapper: {
    padding: "1.875rem 1.25rem",
  },
  cardsContainer: {
    display: "flex",
    gap: "0.938rem",
    [theme.breakpoints.down("xs")]: {
      flexDirection: "column",
    },
  },
}));

export default makeClasses;
